import { Button } from "@bcc/components/ui/button";
import { Card, CardContent } from "@bcc/components/ui/card";
import { FileText, Package, Printer, X } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { setBatchActionsTestId } from "./batch-actions.utils";
import { CreateBatchDialog } from "./create-batch-dialog";

interface BatchActionsProps {
  selectedOrders: string[];
  onClearSelection: () => void;
  testId?: string;
}

export function BatchActions({
  selectedOrders,
  onClearSelection,
  testId,
}: BatchActionsProps) {
  const [showCreateBatch, setShowCreateBatch] = useState(false);
  const { t } = useTranslation();

  return (
    <>
      <Card
        testId={testId ?? setBatchActionsTestId("container")}
        className="border-primary/50 bg-primary/5"
      >
        <CardContent className="flex items-center justify-between p-4">
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-2">
              <Package className="h-5 w-5 text-primary" />
              <span className="font-semibold">
                {t("views.batchActions.ordersSelected", {
                  count: selectedOrders.length,
                })}
              </span>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <Button
              variant="outline"
              size="sm"
              onClick={() => setShowCreateBatch(true)}
            >
              <Package className="mr-2 h-4 w-4" />
              {t("views.batchActions.createBatch")}
            </Button>
            <Button variant="outline" size="sm">
              <Printer className="mr-2 h-4 w-4" />
              {t("views.batchActions.printLabels")}
            </Button>
            <Button variant="outline" size="sm">
              <FileText className="mr-2 h-4 w-4" />
              {t("views.batchActions.packingSlips")}
            </Button>
            <Button variant="ghost" size="icon" onClick={onClearSelection}>
              <X className="h-4 w-4" />
            </Button>
          </div>
        </CardContent>
      </Card>

      <CreateBatchDialog
        open={showCreateBatch}
        onOpenChange={setShowCreateBatch}
        selectedOrders={selectedOrders}
        onSuccess={onClearSelection}
      />
    </>
  );
}
